import React, { useState, useEffect, useRef } from "react";
import QrReader from "modern-react-qr-reader";
import BarcodeReader from "react-barcode-reader";
import Grid from '@mui/material/Grid';
import { Button, Typography, Box } from '@mui/material';
import axios from 'axios';
import swal from "sweetalert";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useParams } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const ConferenceAttendance = (props) => {
    const eventid = props.match.params.id;
    //const id = props.match.params.id;

    const inputRef = useRef(null);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState('');
    const [result, setResult] = useState("");
    const [singleWorkshopData, setsingleWorkshopData] = useState('');
    const [particpantAttendiData, setParticpantAttendiData] = useState([]);
    const [permissions, setrPermissions] = useState([]);
    //const [eventid, setEventId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [facingMode, setFacingMode] = useState("environment");
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [inputValue, setInputValue] = useState("");
    const [affiliationFilter, setAffiliationFilter] = useState('');


    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    let backGroundButtonByEvent = "";
    let backGroundByEvent = "";

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
        backGroundByEvent = `${abstractHomeSetup.color_code}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
        backGroundByEvent = "#145348";
    }
    //backgroundColor: backGroundButtonByEvent,



    React.useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)
            } else {

            }
        })

    }, []);

    useEffect(() => {
        axios.get(`api/conference-single/${eventid}`).then((res) => {
            if (res.status === 200) {
                const wrkshp = res.data.ccp;
                setsingleWorkshopData(wrkshp);
                // if (wrkshp.event_id !== null) {
                //     setEventId(wrkshp.event_id);
                // }
                setLoading(false);
            }
        });
    }, [eventid]);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredRows = particpantAttendiData?.filter((row) =>
        Object.values(row).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )

    );
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;



    useEffect(() => {
        let filteredData = particpantAttendiData?.filter((row) => {
            const nameMatches = row.participant_name?.toLowerCase().includes(searchTerm.toLowerCase());
            const dateMatches = searchDate ? row.datetime?.includes(searchDate) : true;
            return nameMatches && dateMatches;
        });

        setFilteredPosts(filteredData);
    }, [searchTerm, searchDate, particpantAttendiData]);


    const totalRecords = particpantAttendiData?.length;
    const filteredRecordsCount = filteredPosts?.length;


    const handleScan = (data) => {
        if (data) {
            setResult(data);
        }
    };
    const handleChange = (event) => {
        const value = event.target.value; // Get the new value from the input
        setInputValue(value); // Update the input value manually
        setResult(value); // Directly update the result with the new value
    };


    const handleError = (error) => {
        console.error(error);
    };

    useEffect(() => {

        if (eventid !== null) {
            if (result) {
                sendDataToAPI(result);
            }

        }
    }, [eventid, result]);

    const toggleCamera = () => {
        setFacingMode(prevMode => (prevMode === "user" ? "environment" : "user"));
    };

    const resetResult = () => {
        setResult('');
        setInputValue('');
        if (inputRef.current) {
            inputRef.current.focus();
        }

    };



    const sendDataToAPI = async (data) => {
        try {
            if (!eventid) {
                console.log('eventId is null, sendDataToAPI function not executed.');
                return;
            }

            await axios.get('/sanctum/csrf-cookie');

            const sendPayload = { eventid, data };
            const response = await axios.post(`/api/store-conference-qrcode-scan-data`, sendPayload);
            const { status, message } = response.data;

            // Show SweetAlert for all statuses
            switch (status) {
                case 200:
                    swal('Success', message, 'success');
                    break;
                case 201:
                case 203:
                case 403:
                    swal('Warning', message, 'warning');
                    break;
                case 404:
                    swal('Error', message, 'error');
                    break;
                default:
                    swal('Info', message || 'Unknown response', 'info');
            }

            // Fetch updated attendee data only on success
            if (status === 200) {
                try {
                    const res = await axios.get(`api/conference-attendi/${eventid}`);
                    if (res.status === 200 && res.data.status === 200) {
                        // Backend already returns flat data
                        setParticpantAttendiData(res.data.attendance);
                    } else {
                        swal('Error', 'Check API: Something went wrong', 'error');
                    }
                } catch (err) {
                    console.error('Error fetching updated attendee data:', err);
                    swal('Error', 'Failed to fetch updated attendee data', 'error');
                }
            }

        } catch (error) {
            console.error('Error sending data to API:', error);
            swal('Error', 'An error occurred while sending data', 'error');
        }
    };



    useEffect(() => {
        if (!eventid) return;

        axios.get(`api/conference-attendi/${eventid}`)
            .then(res => {
                if (res.status === 200 && res.data.status === 200) {
                    // No need to flatten, backend already returns flat data
                    setParticpantAttendiData(res.data.attendance);
                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            })
            .catch(err => {
                console.error('Error fetching attendance data:', err);
                swal('Error', 'Failed to fetch attendance data', 'error');
            });
    }, [eventid]);





    const convertToCSV = (data) => {
        try {
            if (!data || data.length === 0) {
                console.error('Data array is empty or undefined');
                return '';
            }

            const fieldMappings = {
                participant_id: 'Participant ID',
                participant_name: 'Participant Name',
                session_name: 'Session Name',
                topic_name: 'Topic Name',
                speaker_name: 'Speaker Name',
                datetime: 'Date and Time',
            };

            const headers = Object.values(fieldMappings);

            const rows = data.map((row) => [
                row.participant_id || '',
                row.participant_name || '',
                row.session_name || '',
                row.topic_name || '',
                row.speaker_name || '',
                row.datetime || '',
            ]);

            const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');

            return csvContent;
        } catch (error) {
            console.error('Error converting data to CSV:', error);
            return '';
        }
    };

    // Download function
    const handleDownloadParticipantAttendanceDataCSV = () => {
        const csvData = convertToCSV(filteredPosts);

        if (!csvData) {
            swal('Error', 'No data available for download', 'error');
            return;
        }

        const csvBlob = new Blob([csvData], { type: 'text/csv' });
        const csvUrl = window.URL.createObjectURL(csvBlob);

        const downloadLink = document.createElement('a');
        downloadLink.href = csvUrl;
        downloadLink.download = `${singleWorkshopData.eventname || 'attendance'}_participant_attendance.csv`;
        downloadLink.click();

        window.URL.revokeObjectURL(csvUrl);
    };





    if (loading) {
        return <div>Loading...</div>;
    }


    return (
        <div style={{ minHeight: '100vh', maxWidth: '100%', padding: '0 20px' }}>
            <header style={{ marginBottom: '20px', backgroundColor: backGroundByEvent, color: 'white', textAlign: 'center' }}>
                {/* <Typography variant="h4" >Event: {singleWorkshopData.eventname}</Typography> */}
                <Typography variant="h4" sx = {{pt:3}} >Event / Conference</Typography>
                <Typography component="h6" variant="h6" sx={{ m: 1 }}>
                    {singleWorkshopData.eventname}
                </Typography>
                <Typography component="h6" variant="h6" >Conference Attendance</Typography>
            </header>
            <Grid container spacing={2} alignItems="flex-start" justify="center">
                <Grid item xs={12} sm={6} align="center">
                    <QrReader
                        delay={300}
                        onError={handleError}
                        onScan={handleScan}
                        style={{ width: '100%', maxWidth: '350px' }}
                        facingMode={facingMode} />

                    <Grid item xs={12} sm={5} style={{ marginTop: "20px" }}>
                        <TextField
                            label="Scan Result"
                            value={inputValue}
                            onChange={handleChange} // Update value manually from input field
                            variant="outlined"
                            fullWidth
                            autoFocus
                            inputRef={inputRef}

                        />
                    </Grid>

                    {result && (
                        <div>
                            <Typography variant="h6" sx={{ m: 2 }}>Result:</Typography>
                            <Typography>ID: {result}</Typography>
                            <Button variant="contained" color="primary" onClick={resetResult}>
                                Clear Result
                            </Button>
                        </div>
                    )}


                    <Button
                        variant="contained"
                        color="primary"
                        onClick={toggleCamera}
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            marginTop: { xs: 2, sm: 2, md: 3, lg: 4 },
                            width: { xs: '100%', sm: '100%', md: 'auto', lg: 'auto' },
                        }}
                    >
                        {facingMode === "user" ? "Switch to Back Camera" : "Switch to Front Camera"}
                    </Button>


                </Grid>
                <Grid item xs={12} sm={6} align="center">

                    <Typography sx={{ margin: '2%', fontWeight: 'bold', color: 'text.secondary' }}>
                        Total Records: {totalRecords} | Filtered Records: {filteredRecordsCount}
                    </Typography>
                    <Grid container spacing={2}>
                        {/* Name Filter */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Filter By: Name"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Grid>

                        {/* Date Filter */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Filter By: Date (YYYY-MM-DD)"
                                value={searchDate}
                                onChange={(e) => setSearchDate(e.target.value)}
                                type="date"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                    <TableContainer component={Paper} sx={{ mt: 5 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', mb: 2 }}>
                            {/* Download CSV button */}
                            {permissions['p_conference-attendance-download'] === true && (
                                <Button
                                    onClick={handleDownloadParticipantAttendanceDataCSV}
                                    sx={{
                                        marginBottom: 2,
                                        backgroundColor: backGroundButtonByEvent,
                                        ":hover": {
                                            color: "white",
                                            backgroundColor: 'green',
                                        },
                                        padding: '8px 16px',
                                    }}
                                    color='success'
                                    size='small'
                                    variant='contained'
                                >
                                    <FileDownloadIcon sx={{ marginRight: 1 }} />
                                    Download CSV
                                </Button>
                            )}

                            {/* Affiliation filter (optional) */}
                            <FormControl sx={{ minWidth: 200, mb: 2 }}>
                                <InputLabel id="affiliation-filter-label">Filter By Affiliation</InputLabel>
                                <Select
                                    labelId="affiliation-filter-label"
                                    id="affiliation-filter"
                                    value={affiliationFilter}
                                    label="Filter By Affiliation"
                                    onChange={(e) => setAffiliationFilter(e.target.value)}
                                    sx={{
                                        '.MuiOutlinedInput-root': { borderRadius: '8px' },
                                        '.MuiSelect-icon': { right: '8px' },
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="1">Affiliated</MenuItem>
                                    <MenuItem value="0">Not Affiliated</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <hr />

                        <Table>
                            <TableHead>
                                <TableRow>
                                    {isMobile ? (
                                        <TableCell colSpan={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            Participant Attendance Details
                                        </TableCell>
                                    ) : (
                                        <>
                                            <TableCell>Participant QrCode ID</TableCell>
                                            <TableCell>Participant Name</TableCell>
                                            <TableCell>Session Name</TableCell>
                                            <TableCell>Topic Name</TableCell>
                                            <TableCell>Speaker Name</TableCell>
                                            <TableCell>Date & Time</TableCell>
                                        </>
                                    )}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {console.log("filteredPosts", filteredPosts)}
                                {

                                    filteredPosts?.slice(startIndex, endIndex).map((row, index) => (
                                        <TableRow key={index}>
                                            {isMobile ? (
                                                <>
                                                    <Box style={{ margin: '5px' }}><strong>Session:</strong> {row.session_name}</Box>
                                                    <Box style={{ margin: '5px' }}><strong>Topic:</strong> {row.topic_name}</Box>
                                                    <Box style={{ margin: '5px' }}><strong>Speaker:</strong> {row.speaker_name}</Box>
                                                    <Box style={{ margin: '5px' }}><strong>Participant:</strong> {row.participant_name}</Box>
                                                    <Box style={{ margin: '5px' }}><strong>Date:</strong> {row.datetime}</Box>
                                                    <hr />
                                                </>
                                            ) : (
                                                <>
                                                    <TableCell>{row.participant_id}</TableCell>
                                                    <TableCell>{row.participant_name}</TableCell>
                                                    <TableCell>{row.session_name}</TableCell>
                                                    <TableCell>{row.topic_name}</TableCell>
                                                    <TableCell>{row.speaker_name}</TableCell>
                                                    <TableCell>{row.datetime}</TableCell>
                                                </>
                                            )}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]}
                            component="div"
                            count={filteredPosts?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>

                </Grid>
            </Grid>
            {/* 
            <footer style={{ position: 'fixed', bottom: '0', left: '0', width: '100%', backgroundColor: 'green', padding: '10px', color: 'white', textAlign: 'center' }}>
               
                <Typography variant="body1">Your footer content here</Typography>
            </footer> */}

        </div>
    );
}

export default ConferenceAttendance;
